const encoder = new TextEncoder();

const CRC_TABLE = (() => {
  const table = new Uint32Array(256);
  for (let n = 0; n < 256; n += 1) {
    let c = n;
    for (let k = 0; k < 8; k += 1) c = (c & 1) ? (0xedb88320 ^ (c >>> 1)) : (c >>> 1);
    table[n] = c >>> 0;
  }
  return table;
})();

function crc32(bytes) {
  let crc = 0xffffffff;
  for (let i = 0; i < bytes.length; i += 1) crc = CRC_TABLE[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
  return (crc ^ 0xffffffff) >>> 0;
}

function dosDateTime(date = new Date()) {
  const year = Math.max(1980, date.getFullYear());
  const dosTime = ((date.getHours() & 0x1f) << 11) | ((date.getMinutes() & 0x3f) << 5) | ((Math.floor(date.getSeconds() / 2)) & 0x1f);
  const dosDate = (((year - 1980) & 0x7f) << 9) | (((date.getMonth() + 1) & 0x0f) << 5) | (date.getDate() & 0x1f);
  return { dosTime, dosDate };
}

function pushU16(target, value) {
  target.push(value & 0xff, (value >>> 8) & 0xff);
}

function pushU32(target, value) {
  target.push(value & 0xff, (value >>> 8) & 0xff, (value >>> 16) & 0xff, (value >>> 24) & 0xff);
}

function appendBytes(target, bytes) {
  for (const byte of bytes) target.push(byte);
}

export function buildStoredZip(entries = []) {
  const local = [];
  const central = [];
  let offset = 0;
  const now = new Date();
  const { dosTime, dosDate } = dosDateTime(now);

  entries.forEach((entry) => {
    const filename = String(entry?.name || "file.txt").replace(/\\/g, "/");
    const nameBytes = encoder.encode(filename);
    const dataBytes = entry?.data instanceof Uint8Array ? entry.data : encoder.encode(String(entry?.data ?? ""));
    const checksum = crc32(dataBytes);
    const localHeader = [];
    pushU32(localHeader, 0x04034b50);
    pushU16(localHeader, 20);
    pushU16(localHeader, 0x0800);
    pushU16(localHeader, 0);
    pushU16(localHeader, dosTime);
    pushU16(localHeader, dosDate);
    pushU32(localHeader, checksum);
    pushU32(localHeader, dataBytes.length);
    pushU32(localHeader, dataBytes.length);
    pushU16(localHeader, nameBytes.length);
    pushU16(localHeader, 0);
    appendBytes(localHeader, nameBytes);
    appendBytes(localHeader, dataBytes);
    appendBytes(local, localHeader);

    const centralHeader = [];
    pushU32(centralHeader, 0x02014b50);
    pushU16(centralHeader, 20);
    pushU16(centralHeader, 20);
    pushU16(centralHeader, 0x0800);
    pushU16(centralHeader, 0);
    pushU16(centralHeader, dosTime);
    pushU16(centralHeader, dosDate);
    pushU32(centralHeader, checksum);
    pushU32(centralHeader, dataBytes.length);
    pushU32(centralHeader, dataBytes.length);
    pushU16(centralHeader, nameBytes.length);
    pushU16(centralHeader, 0);
    pushU16(centralHeader, 0);
    pushU16(centralHeader, 0);
    pushU16(centralHeader, 0);
    pushU32(centralHeader, 0);
    pushU32(centralHeader, offset);
    appendBytes(centralHeader, nameBytes);
    appendBytes(central, centralHeader);
    offset += localHeader.length;
  });

  const end = [];
  pushU32(end, 0x06054b50);
  pushU16(end, 0);
  pushU16(end, 0);
  pushU16(end, entries.length);
  pushU16(end, entries.length);
  pushU32(end, central.length);
  pushU32(end, local.length);
  pushU16(end, 0);

  return new Blob([new Uint8Array(local), new Uint8Array(central), new Uint8Array(end)], { type: "application/zip" });
}
